export default __webpack_public_path__ + "dd0da6ddfa0192956c69b458e8750228.jpg";